function withShopifyCdnWidth(url, width) {
    if (!url || url.indexOf('cdn.shopify.com') === -1) return url;
    try {
        const parsed = new URL(url, window.location.origin);
        parsed.searchParams.set('width', width);
        return parsed.toString();
    } catch (e) {
        return url;
    }
}

class MediaSlider360 extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });

        this.sliderContainerStyle = this.getAttribute('slider-container-style') || '';

        this.sliderTitle = this.getAttribute('slider-title') || '';
        this.sliderTitleStyle = this.getAttribute('slider-title-style') || '';

        this.wrapperStyle = this.getAttribute('wrapper-style') || '';

        this.controlStyle = this.getAttribute('control-style') || '';
        this.controlHoverStyle = this.getAttribute('control-hover-style') || '';
        this.prevControlStyle = this.getAttribute('prev-control-style') || '';
        this.nextControlStyle = this.getAttribute('next-control-style') || '';

        this.thumbnailDesktopOnly = this.getAttribute('thumbnail-desktop-only') || 'false';

        this.thumbnailType = this.getAttribute('thumbnail-type')
        this.thumbnailContainerStyle = this.getAttribute('thumbnail-container-style') || '';
        this.thumbnailStyle = this.getAttribute('thumbnail-style') || '';
        this.thumbnailActiveStyle = this.getAttribute('thumbnail-active-style') || '';
        this.thumbnailImageStyle = this.getAttribute('thumbnail-image-style') || '';
        this.thumbnailHoverStyle = this.getAttribute('thumbnail-hover-style') || '';

        this.slidingTime = this.getAttribute('sliding-time') || '0.3';

        this.dotsContainerStyle = this.getAttribute('dots-container-style') || '';
        this.dotStyle = this.getAttribute('dot-style') || '';
        this.dotActiveStyle = this.getAttribute('dot-active-style') || '';


        this.diamondSizeTextStyle = this.getAttribute('diamond-size-text-style') || '';

        // Click-to-zoom (slides marked with data-zoomable)
        this.zoomScale = parseFloat(this.getAttribute('zoom-scale')) || 2;
        this.zoomedSlide = null;

        // Track 360 viewers - only one can be active at a time
        this.all360ViewerElems = {}
        this.activeViewer = null;
        this.isAnyViewerDragging = false;
        this.sliderWidth = 375;
        this.sliderHeight = 375;
        this.ogSlidesLength = 0;
        this.productCategory = this.getAttribute('product-category') || '';


        this.shadowRoot.innerHTML = `
        <style>
            :host {
                --slider-width: 300px;
                --slider-height: 300px;

                --slider-container-width: 300px;
                --slider-container-height: 300px;
                --slider-container-border: 1px solid lightgray;

                --wrapper-top: 18%;
                --wrapper-left: 5%;

                --slider-title-top: 0;
                --slider-title-font-size: 20px;
                --slider-title-font-weight: 500;

                --thumbnail-container-top: 0;
                --thumbnail-container-left: 2%;

                --dots-container-bottom: 20px;
                --dots-container-left: 44%;

                --thumbnail-width: 50px;
                --thumbnail-height: 50px;

                --control-top: 47%;
                --control-width: 25px;
                --control-height: 25px;
                --control-left: 0;
                --control-right: 0;

                display: block;
            }

            .media-slider-360-container {
                width: 100%;
                max-width: 100%;
                display: flex;
            }

           

            .slider {
                position: relative;
                margin-left: auto;
                margin-right: auto;
                width: var(--slider-container-width);
                height: var(--slider-container-height);
                border: var(--slider-container-border);
                ${this.sliderContainerStyle}
            }

            .wrapper {
                overflow: hidden;
                position: relative;
                width: var(--slider-width);
                height: var(--slider-height);
                top: var(--wrapper-top);
                left: var(--wrapper-left);
                ${this.wrapperStyle}
            }

            .slides {
                width: var(--slider-width);
                height: var(--slider-height);
                display: flex;
                position: relative;
                top: 0;
                cursor: grab;
                user-select: none;
                -webkit-user-select: none;
                touch-action: pan-y pinch-zoom;
            }

            .slides.shifting {
                transition: left ${this.slidingTime}s cubic-bezier(0.4, 0, 0.2, 1);
            }

            /* Click-to-zoom slides. Only 'transform' is transitioned so that
               panning (which moves transform-origin) tracks the cursor instantly. */
            ::slotted([data-zoomable]) {
                cursor: zoom-in;
                transition: transform 0.25s ease;
            }

            ::slotted([data-zoomable].zoomed) {
                cursor: zoom-out;
                position: relative;
                z-index: 1;
            }

            

        
            .control {
                position: absolute;
                z-index: 2;
                cursor: pointer;
                transition: all 0.2s ease;
                top: var(--control-top);
                ${this.controlStyle}
            }

            .control svg {
                width: var(--control-width);
                height: var(--control-height);
            }

            .control.prev {
                left: var(--control-left);
                ${this.prevControlStyle}
            }

            .control.next {
                right: var(--control-right);
                ${this.nextControlStyle}
            }

            .control:hover {
                opacity: 0.8;
                scale: 1.05;
                ${this.controlHoverStyle}
            }

            .desktop-thumbnails {
                display: ${this.thumbnailDesktopOnly == 'true' ? 'flex' : 'none'};
                flex-direction: column;
                align-items: center;
                margin-right: 15px;
                gap:16px;
            }


            .thumbnails {
                margin-left: auto;
                margin-right: auto;
                margin-top: 16px;
                width: var(--slider-container-width);
                position: relative;
                overflow-y: hidden;
                overflow-x: auto;
                display: ${this.thumbnailDesktopOnly == 'true' ? 'none' : 'flex'};
                gap: 10px;
                justify-content: center;
                top: var(--thumbnail-container-top);
                left: var(--thumbnail-container-left);
                ${this.thumbnailContainerStyle}
            }
            .thumbnails.overflowing {
                justify-content: flex-start;
            }
            .thumbnails::-webkit-scrollbar {
                display: none;
            }
            

            .thumbnail {
                cursor: pointer;
                transition: all 0.3s ease;
                border: 1px solid lightgray;
                position:relative;
                width: var(--thumbnail-width);
                height: var(--thumbnail-height);
                ${this.thumbnailStyle}
            }

            .thumbnail:hover {
                border-color: black;
                ${this.thumbnailHoverStyle}
            }

            .thumbnail.active {
                border-color: black;
                ${this.thumbnailActiveStyle}
            }

            .thumbnail img {
                width: var(--thumbnail-width);
                height: var(--thumbnail-height);
                object-fit: cover;
                ${this.thumbnailImageStyle}
            }

            .thumbnail::after {
                content: '';
                display:${this.thumbnailType == 'translucent' ? 'block' : 'none'};
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.6);
                border-radius: 4px;
                transition: background-color 0.3s ease;
            }

            .thumbnail.active::after {
                background-color: rgba(0, 0, 0, 0);
            }

            .slider-title {
                position: absolute;
                margin:0;
                text-align: center;
                z-index: 3;
                width: 100%;
                font-size: var(--slider-title-font-size);
                font-weight: var(--slider-title-font-weight);
                top: var(--slider-title-top);
                ${this.sliderTitleStyle}
            }

            .dots {
                display: flex;
                justify-content: center;
                gap: 8px;
                position: absolute;
                bottom: var(--dots-container-bottom);
                left: var(--dots-container-left);
                transform: translateX(-50%);
                ${this.dotsContainerStyle}
            }

            .dot {
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background: #ccc;
                cursor: pointer;
                transition: all 0.3s ease;
                ${this.dotStyle}
            }

            .dot.active {
                background: #333;
                ${this.dotActiveStyle}
            }

            .loading-spinner {
                display: none;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
            
            .diamond-size-text {
                font-weight: 400;
                font-style: italic;
                font-size: 14px;
                line-height: 20px;
                margin-top: 32px;
                color: rgba(102, 102, 102, 1);
                text-align: center;
                max-width: 400px;
                margin-left: auto;
                margin-right: auto;
                ${this.diamondSizeTextStyle}
            }
            @media only screen and (max-width: 1024px) {
                .desktop-thumbnails {
                    display: none;
                }
            }
            @media only screen and (max-width: 768px) {
                .diamond-size-text {
                    font-weight: 400;
                    font-size: 11px;
                    line-height: 16px;
                    margin-top: 24px;
                    width: 80%;
                }
            }
        </style>

        <div class="media-slider-360-container">
            <div id="desktopThumbnails" class="desktop-thumbnails"></div>
            <div>
                <div id="slider" class="slider">
                    <h3 class="slider-title">${this.sliderTitle}</h3>
                    <div class="wrapper">
                        <div id="slides" class="slides">
                            <slot></slot>
                        </div>
                    <img class="loading-spinner" width="78" height="78" src="https://fergusjames.com/cdn/shop/t/38/assets/loader-dia.svg?v=25917440371860867031726217276">
                    </div>
                    <a id="prev" class="control prev">
                        <svg width="25" height="25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                            <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"></path>
                        </svg>
                    </a>
                    <a id="next" class="control next">
                        <svg width="25" height="25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                            <path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"></path>
                        </svg>
                    </a>
                    <div id="dots" class="dots"></div>
                </div>
                <div id="thumbnails" class="thumbnails"></div>
                <p class="diamond-size-text">All rings show 2ct diamond for illustrative purposes only. Actual diamond to be selected at the next step.</p>
            <div>
        </div>
    `;
    }

    // Add static property to observe the slider-title attribute
    static get observedAttributes() {
        return ['slider-title'];
    }

    // Add attribute change callback
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'slider-title' && oldValue !== newValue) {
            const titleElement = this.shadowRoot.querySelector('.slider-title');
            if (titleElement) {
                titleElement.textContent = newValue;
            }
        }
    }

    // 360 Viewer Creation Function
    create360Viewer(container, baseUrl, frameCount, topImg, sliderWidth, sliderHeight) {
        let images = [];
        let currentFrame = 0;
        let isPlaying = false;
        let isDragging = false;
        let startX = 0;
        let currentX = 0;
        let imagesLoaded = 0;
        let animationFrameId = null;
        let isActive = true;
        const baseFrames = 256;
        const framesCoefficient = frameCount / baseFrames;
        const frameRateReducer = 1;
        const frameRateBooster = 2;
        const minBaseFrames = 32;
        let currentVisibleImg = null;
        const isMobile = window.matchMedia('(max-width: 768px)').matches;
        const rotationSpeed = isMobile ? 2 * framesCoefficient : 2 * framesCoefficient;
        let wasDragging = false;
        let directionFactor = 1;

        let lastTime = 0;
        // how many 360 frames per second you want to advance
        const rotationFps = 24; // tweak this; lower = slower

        // Clear any existing animation on this container
        if (container.viewer) {
            container.viewer.destroy();
        }

        const animate360View = () => {
            if (!isPlaying || isDragging || !isActive) {
                cancelAnimationFrameId();
                lastTime = 0;
                return;
            }

            const now = performance.now();

            if (!lastTime) {
                // first frame – just initialize and schedule next
                lastTime = now;
                animationFrameId = requestAnimationFrame(animate360View);
                return;
            }

            const deltaSeconds = (now - lastTime) / 1000;
            lastTime = now;

            // how many frames to move this tick, based on real time
            const baseFrameStep = rotationFps * deltaSeconds;


            if (frameCount > minBaseFrames) {
                currentFrame = (currentFrame + (baseFrameStep / frameRateReducer) * directionFactor + frameCount) % frameCount;
            } else {
                currentFrame = (currentFrame + baseFrameStep * frameRateBooster * directionFactor + frameCount) % frameCount;
            }

            const calculatedFrame = Math.floor(currentFrame);
            const imageToSet = images[calculatedFrame];

            if (imageToSet) {
                if (currentVisibleImg && currentVisibleImg !== imageToSet) {
                    currentVisibleImg.style.visibility = 'hidden';
                }
                imageToSet.style.visibility = 'visible';
                currentVisibleImg = imageToSet;
            }

            // console.log('now',now, 'lastTime', lastTime, 'calculatedFrame', calculatedFrame, 'baseFrameStep', baseFrameStep, 'rotationFps', rotationFps, 'deltaSeconds', deltaSeconds);

            animationFrameId = requestAnimationFrame(animate360View);
        };

        // Create image elements container
        const imageContainer = document.createElement('div');
        imageContainer.className = 'viewer-360-container';
        imageContainer.style.cssText = 'position: relative;';
        imageContainer.style.width = sliderWidth + 'px';
        imageContainer.style.height = sliderHeight + 'px';
        imageContainer.style.minWidth = sliderWidth + 'px';
        imageContainer.style.minHeight = sliderHeight + 'px';
        container.appendChild(imageContainer);

        // Add loading indicator
        const loadingDiv = document.createElement('div');
        loadingDiv.className = 'viewer-loading';
        loadingDiv.style.cssText = 'position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); text-align: center;';
        loadingDiv.innerHTML = `
        <div>
          <img loading="eager" src="${topImg}" style="max-width: 100%; max-height: 95%; object-fit: contain;"/>
          <span style="${baseUrl.includes('http') ? 'display:block;' : 'display:none;'}">
            Loading 360° View...
          </span>
        </div>`;
        container.appendChild(loadingDiv);

        // Load images
        if (isActive) {
            for (let i = 1; i <= frameCount; i++) {
                const img = new Image();

                if (baseUrl.startsWith("https://cdn.shopify.com/s/files/1/0842/8965/0991/files/v360_Carla-Ecushion-cut")) {
                    img.src = `${baseUrl}${i.toString().padStart(3, '0')}.webp`;
                } else if (baseUrl.startsWith("https://cdn.shopify.com/s/files/1/0842/8965/0991/files/v360_DS_")) {
                    img.src = `${baseUrl}_${(i - 1).toString().padStart(5, '0')}.webp`;
                } else {
                    img.src = `${baseUrl}-${i}.webp`;
                }
                //v360_DS_RD-5CT_ROSE_ 00013
                // v360_DS_RD-4CT_YELLOW_ 00206 
                // v360_DS_RD-5CT_ROSE_ 00009
                // min-width: ${sliderWidth}px;padding-bottom: 10%;transform: scale(1.5);transform-origin: center center;clip-path: inset(22% 22% 22% 22%;-webkit-clip-path: inset(22% 22% 22% 22%);


                img.onload = () => {
                    if (baseUrl.includes("https://cdn.shopify.com/s/files/1/0842/8965/0991/files/v360_Carla-Ecushion-cut")) {
                        img.style.cssText = 'scale:1.1; position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: contain; visibility: hidden; pointer-events:none;';
                    } else {
                        img.style.cssText = 'position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: contain; visibility: hidden; pointer-events:none;';
                    }
                    imageContainer.appendChild(img);
                    images[i - 1] = img;
                    imagesLoaded++;

                    if (imagesLoaded === frameCount) {
                        cancelAnimationFrameId();
                        if (!isPlaying) {
                            isPlaying = true;
                            loadingDiv.remove();
                            animate360View();
                        }
                    } else {
                        if (isPlaying) isPlaying = false;
                        cancelAnimationFrameId();
                    }
                };
                img.onerror = () => {
                    container.viewer.destroy();
                };
            }
        }

        // Touch/Mouse events
        const handleDragStart = (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (isDragging) return;
            isDragging = true;
            this.isAnyViewerDragging = true;
            cancelAnimationFrameId();
            isPlaying = false;
            startX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
            currentX = startX;
            wasDragging = false;
        };

        const handleDragMove = (e) => {
            if (!isDragging) return;
            e.stopPropagation();
            const x = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
            const diff = x - currentX;
            currentX = x;
            const mathSign = Math.sign(diff);
            if (mathSign) directionFactor = -mathSign;
            const calculatedFrame = currentFrame - mathSign * rotationSpeed + frameCount;
            currentFrame = (mathSign === -1 ? Math.ceil(calculatedFrame) : Math.floor(calculatedFrame)) % frameCount;

            const imageToSet = images[currentFrame];
            if (imageToSet) {
                if (currentVisibleImg && currentVisibleImg !== imageToSet) {
                    currentVisibleImg.style.visibility = 'hidden';
                }
                imageToSet.style.visibility = 'visible';
                currentVisibleImg = imageToSet;
            }
            wasDragging = true;
        };

        const handleDragEnd = (e) => {
            if (!isDragging) return;
            isDragging = false;
            this.isAnyViewerDragging = false;
            isPlaying = true;

            lastTime = 0;
            animate360View();

            if (wasDragging) {
                wasDragging = false;
                setTimeout(() => {
                    this.isAnyViewerDragging = false;
                }, 50);
            }
        };

        container.addEventListener('mousedown', handleDragStart);
        container.addEventListener('touchstart', handleDragStart, { passive: false });
        document.addEventListener('mousemove', handleDragMove);
        document.addEventListener('touchmove', handleDragMove, { passive: false });
        document.addEventListener('mouseup', handleDragEnd);
        document.addEventListener('touchend', handleDragEnd);


        function cancelAnimationFrameId() {
            if (animationFrameId) {
                cancelAnimationFrame(animationFrameId);
                animationFrameId = null;
            }
        }

        const viewer = {
            destroy: () => {
                isActive = false;
                isPlaying = false;
                cancelAnimationFrameId();
                container.removeEventListener('mousedown', handleDragStart);
                container.removeEventListener('touchstart', handleDragStart);
                document.removeEventListener('mousemove', handleDragMove);
                document.removeEventListener('touchmove', handleDragMove);
                document.removeEventListener('mouseup', handleDragEnd);
                document.removeEventListener('touchend', handleDragEnd);
                imageContainer.remove();
                container.innerHTML = '';
            },
        };


        container.viewer = viewer;
        return viewer;
    }


    // ----- Click-to-zoom -----------------------------------------------------
    // Any slide carrying [data-zoomable] gets a zoom-in cursor; clicking it
    // scales it up around the clicked point, clicking again zooms back out.

    applyZoomOrigin(element, clientX, clientY) {
        // Measure against the wrapper (the fixed viewing window) rather than the
        // slide itself: the slide's own box moves once it is scaled, which would
        // pin the origin to the cursor and make panning a no-op.
        const wrapper = this.shadowRoot.querySelector('.wrapper');
        const rect = wrapper?.getBoundingClientRect();
        if (!rect?.width || !rect?.height) return;

        const clamp = (value) => Math.min(100, Math.max(0, value));
        const originX = clamp(((clientX - rect.left) / rect.width) * 100);
        const originY = clamp(((clientY - rect.top) / rect.height) * 100);
        element.style.transformOrigin = `${originX}% ${originY}%`;
    }

    clearSlideZoom() {
        this.querySelectorAll('[data-zoomable].zoomed').forEach((element) => {
            element.classList.remove('zoomed');
            element.style.transform = '';
            element.style.transformOrigin = '';
        });
        this.zoomedSlide = null;
    }

    toggleSlideZoom(element, clientX, clientY) {
        if (!element) return;
        const wasZoomed = element.classList.contains('zoomed');
        this.clearSlideZoom();
        if (wasZoomed) return;

        element.classList.add('zoomed');
        this.applyZoomOrigin(element, clientX, clientY);
        element.style.transform = `scale(${this.zoomScale})`;
        this.zoomedSlide = element;
    }

    slide(component, items, slottedElements, sliderWidth, prev, next) {
        if (!component || !items || !slottedElements?.length || !prev || !next || !sliderWidth) return;

        var posX1 = 0,
            posX2 = 0,
            posInitial,
            posFinal,
            threshold = 50,
            slides = slottedElements, // Use slottedElements instead
            slidesLength = slides.length,
            slideSize = sliderWidth,
            index = 0,
            allowShift = true;



        component.clearSlideZoom();

        // Create thumbnails
        const thumbnailsContainer = component.shadowRoot.getElementById('thumbnails');
        const desktopThumbnailsContainer = component.shadowRoot.getElementById('desktopThumbnails');
        // Create thumbnails from slotted elements
        slides.forEach((slide, i) => {
            slide.style.cssText = 'object-fit: cover;';

            const thumb = document.createElement('div');
            thumb.className = 'thumbnail' + (i === 0 ? ' active' : '');

            // Check if this is a 360 viewer slide
            if (slide.hasAttribute('data-v360-url')) {
                const topImg = slide.getAttribute('data-top-img');
                if (topImg) {
                    const img = document.createElement('img');
                    img.src = "https://cdn.shopify.com/s/files/1/0842/8965/0991/files/rb-360-icon.png?v=1777906283&width=112";
                    img.style.objectFit = "contain"
                    thumb.appendChild(img);
                }
            } else {
                // Clone the content for the thumbnail
                const content = slide.cloneNode(true);
                content.classList.remove('slide-element');
                content.classList.remove('slide');
                content.removeAttribute('data-zoomable');
                if (content.tagName === 'IMG' && content.src) {
                    content.src = withShopifyCdnWidth(content.src, 112);
                }
                thumb.appendChild(content);
            }
            thumbnailsContainer.appendChild(thumb);
            desktopThumbnailsContainer.appendChild(thumb.cloneNode(true));
        });

        // Check if thumbnails overflow and adjust alignment
        const checkThumbnailOverflow = () => {
            const isOverflowing = thumbnailsContainer.scrollWidth > thumbnailsContainer.clientWidth;
            thumbnailsContainer.classList.toggle('overflowing', isOverflowing);
        };
        setTimeout(checkThumbnailOverflow, 0);

        const resizeObserver = new ResizeObserver(checkThumbnailOverflow);
        resizeObserver.observe(thumbnailsContainer)


        // Clone multiple slides at both end
        // Note: Clones don't get 360 viewers - only original slides do
        // When we loop around, we'll handle viewer activation based on the logical index

        // Clone for the beginning
        for (let i = slidesLength - 1; i >= 0; i--) {
            const clone = slides[i].cloneNode(true);
            clone.className = 'slide clone';
            component.insertBefore(clone, component.firstElementChild);
        }

        // Clone for the end
        for (let i = 0; i < slidesLength; i++) {
            const clone = slides[i].cloneNode(true);
            clone.className = 'slide clone';
            component.appendChild(clone);
        }

        // Set the initial position of the slides
        console.log('setting initial position', slidesLength, slideSize);
        items.style.left = -(slidesLength * slideSize) + "px";



        this.initialize360Viewers();

        // Update thumbnail click handler with shortest path logic

        thumbnailsContainer.querySelectorAll('.thumbnail').forEach(thumb => {
            thumb.onclick = () => {
                const currentIndex = index;
                const allthumbs = Array.from(thumbnailsContainer.children);
                const indexOfThumb = allthumbs.indexOf(thumb);

                // Calculate both possible paths
                const forwardDiff = indexOfThumb >= currentIndex
                    ? indexOfThumb - currentIndex
                    : slidesLength - currentIndex + indexOfThumb;
                const backwardDiff = currentIndex >= indexOfThumb
                    ? currentIndex - indexOfThumb
                    : currentIndex + (slidesLength - indexOfThumb);

                console.log('forwardDiff', forwardDiff, 'backwardDiff', backwardDiff, 'indexOfThumb', indexOfThumb, 'currentIndex', currentIndex);
                console.log("normal diff", indexOfThumb - currentIndex);

                if (forwardDiff == 0 && backwardDiff == 0) {
                    return;
                }
                // Choose the shorter path
                if (forwardDiff < backwardDiff) {
                    shiftSlide(1, null, forwardDiff);
                } else if (forwardDiff > backwardDiff) {
                    shiftSlide(-1, null, backwardDiff);
                } else {
                    shiftSlide(indexOfThumb - currentIndex > 0 ? 1 : -1, null, forwardDiff);
                }
            }
        });


        desktopThumbnailsContainer.querySelectorAll('.thumbnail').forEach(thumb => {
            thumb.onclick = () => {
                const currentIndex = index;
                const allthumbs = Array.from(desktopThumbnailsContainer.children);
                const indexOfThumb = allthumbs.indexOf(thumb);

                // Calculate both possible paths
                const forwardDiff = indexOfThumb >= currentIndex
                    ? indexOfThumb - currentIndex
                    : slidesLength - currentIndex + indexOfThumb;
                const backwardDiff = currentIndex >= indexOfThumb
                    ? currentIndex - indexOfThumb
                    : currentIndex + (slidesLength - indexOfThumb);

                console.log('forwardDiff', forwardDiff, 'backwardDiff', backwardDiff, 'indexOfThumb', indexOfThumb, 'currentIndex', currentIndex);
                console.log("normal diff", indexOfThumb - currentIndex);

                if (forwardDiff == 0 && backwardDiff == 0) {
                    return;
                }
                // Choose the shorter path
                if (forwardDiff < backwardDiff) {
                    shiftSlide(1, null, forwardDiff);
                } else if (forwardDiff > backwardDiff) {
                    shiftSlide(-1, null, backwardDiff);
                } else {
                    shiftSlide(indexOfThumb - currentIndex > 0 ? 1 : -1, null, forwardDiff);
                }
            }
        });


        const dotsContainer = component.shadowRoot.getElementById('dots');
        slides.forEach((_, i) => {
            const dot = document.createElement('div');
            dot.className = 'dot' + (i === 0 ? ' active' : '');
            dotsContainer.appendChild(dot);

            dot.onclick = () => {
                const currentIndex = index;
                const allDots = Array.from(dotsContainer.children);
                const indexOfDot = allDots.indexOf(dot);

                // Calculate shortest path logic (same as thumbnails)
                const forwardDiff = indexOfDot >= currentIndex
                    ? indexOfDot - currentIndex
                    : slidesLength - currentIndex + indexOfDot;
                const backwardDiff = currentIndex >= indexOfDot
                    ? currentIndex - indexOfDot
                    : currentIndex + (slidesLength - indexOfDot);

                if (forwardDiff === 0 && backwardDiff === 0) return;

                if (forwardDiff < backwardDiff) {
                    shiftSlide(1, null, forwardDiff);
                } else if (forwardDiff > backwardDiff) {
                    shiftSlide(-1, null, backwardDiff);
                } else {
                    shiftSlide(indexOfDot - currentIndex > 0 ? 1 : -1, null, forwardDiff);
                }
            };
        });

        // Mouse events

        // Store handler functions for cleanup
        const prevClickHandler = () => shiftSlide(-1);
        const nextClickHandler = () => shiftSlide(1);

        // Remove all events
        items.onpointerdown = null;
        items.onpointermove = null;
        items.onpointerup = null;
        items.onpointercancel = null;
        items.onmousemove = null;
        items.ontransitionend = null;
        prev.onclick = null;
        next.onclick = null;


        // Add Events
        items.onpointerdown = dragStart;
        prev.onclick = prevClickHandler;
        next.onclick = nextClickHandler;

        // Pan a zoomed slide by moving the cursor over it (mouse only).
        items.onmousemove = (e) => {
            const zoomed = component.zoomedSlide;
            if (!zoomed || e.buttons) return;
            component.applyZoomOrigin(zoomed, e.clientX, e.clientY);
        };

        // Add backup timeout for transition
        let transitionTimeout;

        items.ontransitionend = () => {
            clearTimeout(transitionTimeout);
            checkIndex();
        };

        function dragStart(e) {
            // Check if dragging on a 360 viewer container
            const target = e.target;
            const is360Container = target.closest('[data-v360-url]');

            if (is360Container || component.isAnyViewerDragging) {
                return; // Don't start slider drag if on 360 viewer
            }

            e.preventDefault();

            component.pointerDownTarget = target;
            component.pointerDownX = e.clientX;
            component.pointerDownY = e.clientY;

            posInitial = items.offsetLeft;
            items.setPointerCapture(e.pointerId);
            items.style.touchAction = 'none';

            posX1 = e.clientX;
            this.touchStartX = e.clientX;
            this.touchStartY = e.clientY;

            items.onpointermove = dragAction;
            items.onpointerup = dragEnd;
            items.onpointercancel = dragEnd;
        }

        function dragAction(e) {
            var deltaX = 0;
            var deltaY = 0;
            if (e.type == 'touchmove') {
                // Calculate drag direction
                deltaX = Math.abs(e.touches[0].clientX - this.touchStartX);
                deltaY = Math.abs(e.touches[0].clientY - this.touchStartY);

                posX2 = posX1 - e.touches[0].clientX;
                posX1 = e.touches[0].clientX;
            } else {
                deltaX = Math.abs(e.clientX - this.touchStartX);
                deltaY = Math.abs(e.clientY - this.touchStartY);

                posX2 = posX1 - e.clientX;
                posX1 = e.clientX;
            }

            items.style.left = (items.offsetLeft - posX2) + "px";

            if (deltaX > deltaY) {
                items.style.touchAction = 'none';
            } else {
                items.style.touchAction = 'pan-y pinch-zoom';
            }
        }

        function dragEnd(e) {
            items.releasePointerCapture(e.pointerId);
            items.style.touchAction = 'pan-y pinch-zoom';
            posFinal = items.offsetLeft;

            const movedX = Math.abs(e.clientX - component.pointerDownX);
            const movedY = Math.abs(e.clientY - component.pointerDownY);
            const zoomTarget = component.pointerDownTarget?.closest?.('[data-zoomable]');

            if (zoomTarget && movedX < 8 && movedY < 8) {
                items.style.left = posInitial + 'px';
                component.toggleSlideZoom(zoomTarget, e.clientX, e.clientY);

                items.onpointermove = null;
                items.onpointerup = null;
                items.onpointercancel = null;
                return;
            }

            if (posFinal - posInitial < -threshold) {
                shiftSlide(1, 'drag');
            } else if (posFinal - posInitial > threshold) {
                shiftSlide(-1, 'drag');
            } else {
                items.style.left = (posInitial) + "px";
            }

            // Cleanup
            items.onpointermove = null;
            items.onpointerup = null;
            items.onpointercancel = null;
        }

        function shiftSlide(dir, action, amount = 1) {
            if (!allowShift) return
            allowShift = false

            component.clearSlideZoom();

            items.classList.add('shifting');

            console.log('shifting', dir, action, amount, index, allowShift);

            clearTimeout(transitionTimeout);
            transitionTimeout = setTimeout(() => {
                if (items.classList.contains('shifting')) {
                    console.log('using transition timeout');
                    checkIndex();
                }
            }, parseFloat(component.slidingTime) * 1000 + 100);

            if (!action) { posInitial = items.offsetLeft; }
            if (dir == 1) {
                items.style.left = (posInitial - (slideSize * amount)) + "px";
                index += amount;
            } else if (dir == -1) {
                items.style.left = (posInitial + (slideSize * amount)) + "px";
                index -= amount;
            }
        }


        function checkIndex() {
            items.classList.remove('shifting');

            if (index < 0) {
                // Force immediate style update
                items.style.transition = 'none';
                items.offsetHeight; // Force reflow
                items.style.left = -(slidesLength + (slidesLength + index)) * slideSize + "px";
                index = slidesLength - Math.abs(index);
                items.offsetHeight; // Force reflow
                items.style.transition = ''; // Restore transition
            }

            if (index >= slidesLength) {
                // Force immediate style update
                items.style.transition = 'none';
                items.offsetHeight; // Force reflow
                items.style.left = -(slidesLength + (index - slidesLength)) * slideSize + "px";
                index = Math.abs(index) - slidesLength;
                items.offsetHeight; // Force reflow
                items.style.transition = ''; // Restore transition
            }


            console.log('index', index);

            const thumbnails = thumbnailsContainer.getElementsByClassName('thumbnail');
            Array.from(thumbnails).forEach((thumb, i) => {
                thumb.classList.toggle('active', i === index);
            });
            const desktopThumbnails = desktopThumbnailsContainer.getElementsByClassName('thumbnail');
            Array.from(desktopThumbnails).forEach((thumb, i) => {
                thumb.classList.toggle('active', i === index);
            });
            const dots = dotsContainer.getElementsByClassName('dot');
            Array.from(dots).forEach((dot, i) => {
                dot.classList.toggle('active', i === index);
            });

            // Handle 360 viewer activation - only one active at a time
            component.activateViewerForSlide(index);

            allowShift = true;
        }
    }

    connectedCallback() {
        this.initialized = false;
        this.isReinitializing = false;

        this.observer = new MutationObserver((mutations) => {
            const relevantChanges = mutations.some(mutation =>
                Array.from(mutation.addedNodes)
                    .some(node => node.classList?.contains('slide-element'))
                ||
                Array.from(mutation.removedNodes).some(node =>
                    node.classList?.contains('slide-element')
                )
            );
            if (!relevantChanges) {
                console.log('Skipping - no relevant changes');
                return;
            }
            this.initializeSlider();
        });

        this.observer.observe(this, { childList: true, subtree: true });
    }


    disconnectedCallback() {
        this.observer.disconnect();

        // Clean up all 360 viewers
        Object.values(this.all360ViewerElems).forEach(element => {
            if (element && element.viewer && element.viewer.destroy) {
                element.viewer.destroy();
            }
        });
        if (this.activeViewer) {
            this.activeViewer.destroy();
            this.activeViewer = null;
        }
        this.all360ViewerElems = {};
        this.activeViewer = null;
    }

    initializeSlider() {
        if (this.isReinitializing) {
            console.log('Skipping - reinitialization in progress');
            return;
        }
        const loadingSpinner = this.shadowRoot.querySelector('.loading-spinner');
        loadingSpinner.style.display = 'block';

        console.log('Processing changes, initialized:', this.initialized, this.isReinitializing);
        console.log('initializeSlider');

        const sliderContainer = this.shadowRoot.getElementById('slides');
        const prev = this.shadowRoot.getElementById('prev');
        const next = this.shadowRoot.getElementById('next');
        const elementsToSlide = this.querySelectorAll('.slide.slide-element');

        const component = this; // Store reference to component
        this.ogSlidesLength = elementsToSlide.length;

        const imagePromises = Array.from(elementsToSlide).map(async element => {
            if (element.hasAttribute('data-v360-url')) {
                const baseUrl = element.getAttribute('data-v360-url');
                if (!baseUrl) {
                    return Promise.reject(new Error('Missing data-v360-url'));
                }

                let firstFrameSrc = '';
                console.log('baseUrl', baseUrl);

                if (baseUrl.startsWith("https://cdn.shopify.com/s/files/1/0842/8965/0991/files/v360_Carla-Ecushion-cut")) {
                    firstFrameSrc = `${baseUrl}00000.webp`;
                } else if (baseUrl.startsWith("https://cdn.shopify.com/s/files/1/0842/8965/0991/files/v360_DS_")) {
                    firstFrameSrc = `${baseUrl}_00000.webp`;
                } else {
                    firstFrameSrc = `${baseUrl}-1.webp`;
                }
                const response = await fetch(firstFrameSrc);
                if (!response.ok) {
                    element.style.display = 'none';
                    return Promise.reject(new Error(`Failed to fetch first 360 image: ${response.status}`));
                }
                return Promise.resolve(element);
            }
            if (element.complete) {
                return Promise.resolve(element);
            }
            return new Promise((resolve, reject) => {
                element.onload = () => resolve(element);
                element.onerror = () => reject(new Error('Failed to load')); // Handle error case too
            });
        });

        Promise.allSettled(imagePromises).then((results) => {
            const newElementsToSlide = results.filter(result => result.status === 'fulfilled').map(result => result.value);

            const cs = getComputedStyle(this);
            const cw = parseFloat(cs.getPropertyValue('--slider-width'));
            const ch = parseFloat(cs.getPropertyValue('--slider-height'));
            if (cw > 0) this.sliderWidth = Math.round(cw);
            if (ch > 0) this.sliderHeight = Math.round(ch);

            if (!(this.sliderWidth > 0) || !(this.sliderHeight > 0)) {
                for (let i = 0; i < newElementsToSlide.length; i++) {
                    const el = newElementsToSlide[i];
                    if (el?.width && el.width > 0) {
                        if (!(this.sliderWidth > 0)) this.sliderWidth = el.width;
                        if (!(this.sliderHeight > 0)) this.sliderHeight = el.height;
                        break;
                    }
                }
            }

            if (!(this.sliderWidth > 0) || !(this.sliderHeight > 0)) {
                this.sliderWidth = 375;
                this.sliderHeight = 375;
            }

            if (this.initialized) {
                console.log('reinitializing');
                this.isReinitializing = true;

                // Destroy all 360 viewers
                Object.values(this.all360ViewerElems).forEach(element => {
                    if (element && element.viewer && element.viewer.destroy) {
                        element.viewer.destroy();
                    }
                });
                this.all360ViewerElems = {};
                this.activeViewer = null;

                this.shadowRoot.querySelectorAll('.clone').forEach(clone => clone.remove());
                this.shadowRoot.querySelectorAll('.slide').forEach(slide => slide.remove());

                this.shadowRoot.getElementById('thumbnails').innerHTML = '';
                this.shadowRoot.getElementById('desktopThumbnails').innerHTML = '';
                this.shadowRoot.getElementById('dots').innerHTML = '';

                this.initialized = false;
            }

            loadingSpinner.style.display = 'none';
            console.log('newElementsToSlide', newElementsToSlide);
            this.slide(component, sliderContainer, newElementsToSlide, this.sliderWidth, prev, next);

            // Initialize 360 viewers for elements with data-v360-url attribute

            this.initialized = true;
            this.isReinitializing = false;
            console.log('slider2 is initialized');
        });
    }

    initialize360Viewers = async () => {
        // Find all slide elements with 360 viewer data attributes
        const slideElements = this.querySelectorAll('.slide');
        console.log('slideElementskmkm', slideElements);

        slideElements.forEach(async (element, idx) => {
            if (element.hasAttribute('data-v360-url')) {
                const baseUrl = element.getAttribute('data-v360-url');
                if (baseUrl && baseUrl.includes('http')) {
                    // Clear the element and create viewer
                    element.innerHTML = '';
                    element.style.minWidth = this.sliderWidth + 'px';
                    element.style.minHeight = this.sliderHeight + 'px';
                    element.style.width = this.sliderWidth + 'px';
                    element.style.height = this.sliderHeight + 'px';

                    element.style.position = 'relative';
                    this.all360ViewerElems[`${idx}`] = element;
                }
            }
        });

        // Activate viewer for first slide if it has one
        // The first original slide is at physical index = slidesLength
        // Physical layout: [clones, originals, clones]
        const firstSlidePhysicalIndex = `${this.ogSlidesLength}`; // First original slide position

        if (this.all360ViewerElems[firstSlidePhysicalIndex]) {
            this.turnoff360Viewers();
            console.log('Activating first slide 360 viewer at physical index:', firstSlidePhysicalIndex);
            this.turnOn360View(this.all360ViewerElems[firstSlidePhysicalIndex]);
        }
        console.log('all360ViewersElem', this.all360ViewerElems, this.activeViewer);
    }


    turnOn360View(element) {
        if (!element) {
            if (this.productCategory === 'Diamond Studs') {
                this.shadowRoot.querySelector('.slider').style.backgroundColor = '#f7f7f7';
            }
            return
        };
        const baseUrl = element.getAttribute('data-v360-url');
        if (!baseUrl || !baseUrl.includes('http')) return;
        const frameCount = parseInt(element.getAttribute('data-frame-count')) || 72;
        const topImg = element.getAttribute('data-top-img') || '';
        this.create360Viewer(element, baseUrl, frameCount, topImg, this.sliderWidth, this.sliderHeight);
        this.activeViewer = element.viewer;
        if (this.productCategory === 'Diamond Studs') {
            this.shadowRoot.querySelector('.slider').style.backgroundColor = '#fff';
        }
    }

    turnoff360Viewers() {
        if (this.activeViewer) {
            this.activeViewer.destroy();
            this.activeViewer = null;
        }
        //redundant code, but just in case
        Object.values(this.all360ViewerElems).forEach(element => {
            if (element && element.viewer && element.viewer.destroy) {
                element.viewer.destroy();
            }
        });
    }


    activateViewerForSlide(slideIndexNum) {
        // slideIndexNum is the logical index (0, 1, 2...)
        // But viewers are stored by physical index
        // Physical layout: [clones, originals, clones]
        this.turnoff360Viewers();
        const physicalIndex = this.ogSlidesLength + slideIndexNum; // Original slides start at slidesLength
        const physicalIndexKey = `${physicalIndex}`;
        console.log("Activating viewer - logical index:", slideIndexNum, "physical index:", physicalIndex, "Has viewer:", !!this.all360ViewerElems[physicalIndexKey]);
        this.turnOn360View(this.all360ViewerElems[physicalIndexKey]);
    }
}

customElements.define('media-slider-360', MediaSlider360);